module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Buttwil-75b8aacda5c11da5815cbff1524fd9d4.svg";